// extracted by mini-css-extract-plugin
export var readonly = "_ef-1";
export var star = "_ef-0";